import { render, staticRenderFns } from "./workflowReopenBtn.vue?vue&type=template&id=44240874&"
import script from "./workflowReopenBtn.vue?vue&type=script&lang=js&"
export * from "./workflowReopenBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports